import { Theme } from '@mui/material';
/**
 * Styling for ccf-app-queue-counter-channel
 * @returns ccf-app-queue-counter-channel CSS properties as a JSON object
 * @example CcfQueueCounterChannelsStyles(theme)
 */
const CcfQueueCounterChannelsStyles = (theme: Theme, isLessThanLg: boolean, isAppSpace?: boolean) => {
  const styles = {
    channelDetails:{
      height: 'calc(100% - 33px)',
      overflowY: 'auto',
    },
    tableDetails:{
      marginTop: '1rem',
    },
    iconHeaderClasses:{
      marginLeft:'15px',
      color:theme.palette.text.contrastText,
      fontWeight:'normal',
      textOverflow:'ellipsis',
      overflow:'hidden',
      whiteSpace:'nowrap',
    },
    tableStyle:{
      width:'100%',
      tableLayout:'fixed',
      backgroundColor:theme.palette.background.paper,
      borderCollapse:'collapse',
    },
    containerBox:{
      display: 'flex',
      alignItems: 'center',
    },
    channelTitle: {
      fontWeight:'bold',      
      color: theme.palette.text.secondary ,
      paddingLeft: '0.313rem',
      paddingTop:'0.5rem',
      width: 'fit-content',      
      cursor: isAppSpace || isLessThanLg ? 'default' : 'pointer',
    },
    tableHeadRow: {      
      'td,th':{
        color:theme.palette.secondary.main,
        fontWeight:'bold',              
        textTransform: 'uppercase',
        backgroundColor:theme.palette.background.paper,
        textAlign:'left',
      },      
      borderBottom: '0.1875rem solid ',
      borderBottomColor: theme.palette.background.LogoColor,
      fontWeight:'bold',       
    },
    tableBodyRow:{
      'td, th': {
        
        textAlign:'left',
        color:theme.palette.text.contrastText,        
      } ,
      'td:nth-child(4)': {
        textAlign:'right',          
      },      
      borderTop:'0.1875rem solid',
      borderTopColor: theme.palette.background.LogoColor,
      borderBottom:'0.1875rem solid',
      borderBottomColor: theme.palette.background.LogoColor,
      cursor: 'pointer',  
    },
    navigationIcon: {
      width: '1rem',
      height: '1rem',
      fill:theme.palette.text.black,
    },
    customTableContainer: {    
      height:'90%',
      borderCollapse:'collapse',    
    },
  };
  return styles;
};

export default CcfQueueCounterChannelsStyles;
